import { render, staticRenderFns } from "./PayTokenDialog.vue?vue&type=template&id=4e3ed620&scoped=true"
import script from "./PayTokenDialog.vue?vue&type=script&lang=js"
export * from "./PayTokenDialog.vue?vue&type=script&lang=js"
import style0 from "./PayTokenDialog.vue?vue&type=style&index=0&id=4e3ed620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ed620",
  null
  
)

export default component.exports